import styles from './SectionHeader.module.css';

export function SectionHeader({ title, dark = false, className = '' }) {
  return (
    <div className={`${styles.head} ${className}`}>
      <h2 className={`${styles.title} ${dark ? styles.dark : ''}`}>{title}</h2>
    </div>
  );
}
